/**
 * How often readings actually arrive from a sensor, in seconds.
 *
 * When battery saver (log) mode is on the sensor batches its readings and
 * uploads them every `log_secs` instead of every `send_interval`, so the log
 * interval wins whenever it is set and longer than the send interval. This
 * matches how the API schedules `next_checkin` (see cron/process-buffer-v2.php).
 *
 * @param sensor
 * @returns {number|null} seconds, or null if the sensor has no usable interval
 */
const getSensorReadingInterval = sensor => {

  if(!sensor) {
    return null;
  }

  const sendInterval = parseInt(sensor.send_interval, 10);
  const logSecs = parseInt(sensor.log_secs, 10);
  const usesLogMode = String(sensor.use_log_mode) === '1';

  if(
    usesLogMode &&
    Number.isFinite(logSecs) &&
    logSecs > 0 &&
    (!Number.isFinite(sendInterval) || logSecs > sendInterval)
  ) {
    return logSecs;
  }

  return Number.isFinite(sendInterval) && sendInterval > 0 ? sendInterval : null;

};

export default getSensorReadingInterval;
